<template>
  <div class="layoutFrameless">
    <div class="sticky-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import travelNav from '@/layouts/travelNav'

export default {
  name: 'layoutFrameless',
  components: {
    // travelNav
  }
}
</script>

<style lang="sass" scoped>
.layoutFrameless
  @apply flex flex-col
  min-height: 100vh
  .sticky-body
    @apply flex-auto
</style>
